import React from "react";
import { connect } from "react-redux";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";


import Timeline from "components/Timeline/Timeline.jsx";
import LinearProgress from '@material-ui/core/LinearProgress';
import Badge from "components/Badge/Badge.jsx";


// @material-ui/icons
import CardTravel from "@material-ui/icons/CardTravel";



// core components

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import DialogActions from "@material-ui/core/DialogActions";
import InputAdornment from "@material-ui/core/InputAdornment";

// @material-ui/icons
import Info from "@material-ui/icons/Info";
import LocationOn from "@material-ui/icons/LocationOn";
import StandInfo from "@material-ui/icons/Description";
import Audit from "@material-ui/icons/Timeline";
import Meter from "@material-ui/icons/NetworkCheck";
import Work from "@material-ui/icons/Build";
import Place from "@material-ui/icons/Place";
import CardIcon from "components/Card/CardIcon.jsx";


import CustomInput from "components/CustomInput/CustomInput.jsx";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import NavPills from "components/NavPills/NavPills.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";


import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import { viewJobRequest } from "../../../actions/jobCard";
import { getJobAuditsRequest } from "../../../actions/audit";
import { Dialog, DialogTitle, DialogContent } from "@material-ui/core";
import { WorkDone } from './workdone/workController'
import { sanitizeDate } from "../../../utils/helpers";
const styles = {
  cardTitle,
  pageSubcategoriesTitle: {
    color: "#3C4858",
    textDecoration: "none",
    textAlign: "center"
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  cardCategory: {
    margin: "0",
    color: "#999999"
  }
};



const CustomSkinMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      key={props.jobCardNumber}
      defaultZoom={13}
      // defaultCenter={{ lat: standInfo.latitude, lng: standInfo.longitude }}
      defaultCenter={{ lat: props.latitude, lng: props.longitude }}
      defaultOptions={{
        scrollwheel: false,
        disableDefaultUI: true,
        zoomControl: true,
        fullscreenControl: true,
      }}
    >
      <Marker position={{ lat: props.latitude, lng: props.longitude }} />

    </GoogleMap>
  ))
);


class JobCardViewComponent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentWillMount() {
    this.props.dispatch(viewJobRequest(this.props.jobNumber))
    this.props.dispatch(getJobAuditsRequest(this.props.jobNumber))
  }

  onClickButton(route) {
    this.props.history.push(`${route}`)
  }

  jobCardPostInspectionStatus(job) {
    if(!job || !job.postInspectionWork) {
      return (<div></div>)
    } else if(job.postInspectionWork.isJobcardPassed) {
      return (<Badge color="success">Passed Inspection</Badge>)
    } else {
      return (<Badge color="danger">Failed Inspection</Badge>)
    }
  }

  render() {
    const { classes } = this.props;
    const job = (this.props.jobsData.viewJobDetails) ? this.props.jobsData.viewJobDetails : {}
    const jobType = (this.props.jobsData.viewJobDetails) ? ((job.type) ? job.type : '- - - - -') : '- - - - -';
    const jobStatus = (this.props.jobsData.viewJobDetails) ? ((job.status) ? job.status : '- - - - -') : '- - - - -';
    const jobProjectName = (this.props.jobsData.viewJobDetails) ? ((job.project) ? job.project.name : '- - - - -') : '- - - - -';
    const jobContractor = (this.props.jobsData.viewJobDetails) ? ((job.contractor) ? job.contractor.firstName + "  " + job.contractor.lastName : '- - - - -') : '- - - - -';
    const jobInspector = (this.props.jobsData.viewJobDetails) ? ((job.inspector) ? job.inspector.firstName + "  " + job.inspector.lastName : '- - - - -') : '- - - - -';
    const jobAuditor = (this.props.jobsData.viewJobDetails) ? ((job.auditor) ? job.auditor.firstName + "  " + job.auditor.lastName : '- - - - -') : '- - - - -';
    const jobManager = (this.props.jobsData.viewJobDetails) ? ((job.manager) ? job.manager.firstName + "  " + job.manager.lastName : '- - - - -') : '- - - - -';
    const jobPriority = (this.props.jobsData.viewJobDetails) ? ((job.isHighPriority !== null) ? job.isHighPriority : '- - - - -') : '- - - - -';
    const jobInstructions = (this.props.jobsData.viewJobDetails) ? ((job.jobInstruction) ? job.jobInstruction : '- - - - -') : '- - - - -';
    const oldMeterNumber = job.oldMeterNumber || '- - - - -';
    const jobClass = job.jobClass || '- - - - -';
    const region = job.region || '- - - - -';
    const municipalityRefNumber = job.municipalityRefNumber || '- - - - -';
    const jobCardNumber = job.jobCardNumber || '';
    const jobCreatedDate = (this.props.jobsData.viewJobDetails) ? ((job.createdAt) ? job.createdAt : '- - - - -') : '- - - - -';

    const standInfo = {
      standNumber: (this.props.jobsData.viewJobDetails) ? ((job.stand.standNumber) ? job.stand.standNumber : '- - - - -') : '- - - - -',
      town: (this.props.jobsData.viewJobDetails) ? ((job.stand.town) ? job.stand.town : '- - - - -') : '- - - - -',
      physicalAddress: (this.props.jobsData.viewJobDetails) ? ((job.stand.physicalAddress) ? job.stand.physicalAddress : '- - - - -') : '- - - - -',
      subdivision: (this.props.jobsData.viewJobDetails) ? ((job.stand.subdivision) ? job.stand.subdivision : '- - - - -') : '- - - - -',
      latitude: (this.props.jobsData.viewJobDetails) ? ((job.stand.latitude) ? job.stand.latitude : '- - - - -') : '- - - - -',
      longitude: (this.props.jobsData.viewJobDetails) ? ((job.stand.longitude) ? job.stand.longitude : '- - - - -') : '- - - - -',
      accountNumber: (this.props.jobsData.viewJobDetails) ? ((job.stand.accountNumber) ? job.stand.accountNumber : '- - - - -') : '- - - - -',
      venusNumber: (this.props.jobsData.viewJobDetails) ? ((job.stand.venusNumber) ? job.stand.venusNumber : '- - - - -') : '- - - - -',
      portion: (this.props.jobsData.viewJobDetails) ? ((job.stand.portion) ? job.stand.portion : '- - - - -') : '- - - - -',
      // standErroCode: (this.props.jobsData.viewJobDetails) ? ((job.stand.standErroCode) ? job.stand.standErroCode :'- - - - -'): '- - - - -',
      contactPerson: (this.props.jobsData.viewJobDetails) ? ((job.stand.contactPerson) ? job.stand.contactPerson : '- - - - -') : '- - - - -',
      contactPhone: (this.props.jobsData.viewJobDetails) ? ((job.stand.contactPhone) ? job.stand.contactPhone : '- - - - -') : '- - - - -',
      notes: (this.props.jobsData.viewJobDetails) ? ((job.stand.notes) ? job.stand.notes : '- - - - -') : '- - - - -',
    }

    const meterTokens = job.newMeter ? (job.newMeter.meterToken || {}) : {};

    const meterInfo = {
      createdAt: (this.props.jobsData.viewJobDetails) ? (job.newMeter ? job.newMeter.createdAt : '- - - - -') : '- - - - -',
      description: (this.props.jobsData.viewJobDetails) ? (job.newMeter ? job.newMeter.description : '- - - - -') : '- - - - -',
      meterNumber: (this.props.jobsData.viewJobDetails) ? (job.newMeter ? job.newMeter.meterNumber : '- - - - -') : '- - - - -',
      meterReading: (this.props.jobsData.viewJobDetails) ? (job.newMeter ? job.newMeter.meterReading : '- - - - -') : '- - - - -',
      meterSerialNumber: (this.props.jobsData.viewJobDetails) ? (job.newMeter ? job.newMeter.meterSerialNumber : '- - - - -') : '- - - - -',
      picUrl: (this.props.jobsData.viewJobDetails) ? (job.newMeter ? job.newMeter.picUrl : '- - - - -') : '- - - - -',
      meterDialType: (this.props.jobsData.viewJobDetails) ? (job.newMeter ? job.newMeter.meterDialType : '- - - - -') : '- - - - -',
      meterType: (this.props.jobsData.viewJobDetails) ? (job.newMeter ? job.newMeter.meterTyper : '- - - - -') : '- - - - -',
      keyChange2: meterTokens.keyChange2 || '- - - - -',
      keyChange1: meterTokens.keyChange1 || '- - - - -',
      temperReset: meterTokens.temperReset || '- - - - -',
      powerLimit: meterTokens.powerLimit || '- - - - -',
      preloadedMeterUnitsToken: meterTokens.preloadedMeterUnitsToken || '- - - - -',
      meterPaymentType: (this.props.jobsData.viewJobDetails) ? (job.newMeter ? job.newMeter.meterPaymentType : '- - - - -') : '- - - - -',
      condition: (this.props.jobsData.viewJobDetails) ? (job.newMeter ? job.newMeter.condition : '- - - - -') : '- - - - -',
      brand: (this.props.jobsData.viewJobDetails) ? (job.newMeter ? job.newMeter.brand : '- - - - -') : '- - - - -',
      Model: "",
      Tag: "",
    }


    const jobTrail = (this.props.audits ? this.props.audits.jobAudits : []).map((audit, index) => ({
      inverted: ((index % 2 == 0) ? true : false), // just alternating between true and false
      badgeColor: "info",
      badgeIcon: CardTravel,
      description: audit.description,
      title: audit.title,
      titleColor: "danger",
      body: (audit.title.includes("STARTED") ?
        (<div> <LinearProgress /> <br /> <LinearProgress color="secondary" /> </div>) :
        (<p> by <strong> {audit.user.firstName}</strong> <br />  <br /> {audit.description}</p>
        )
      ),
      footerTitle: <p> <strong>{sanitizeDate(audit.createdAt)}</strong></p>
    }))

    if (this.props.jobsData.viewJobDetails) {
      return (
        <div>
          <GridContainer justify="center">
            <GridItem xs={12} sm={12} md={12}>
              <div style={{ width: '25%', alignSelf: 'center', margin: '0 auto'}}>
                <GridContainer>
                  <GridItem xs={6} sm={6} md={6}>
                    {
                      
                      job.isJobHighRisk &&
                      <center>
                        <Badge color="danger" style={{ alignSelf: 'center' }}>
                          High Risk Job
                      </Badge>
                      </center>
                    }
                  </GridItem>
                  <GridItem xs={6} sm={6} md={6}>
                    {
                     this.jobCardPostInspectionStatus(job)
                    }

                  </GridItem>
                </GridContainer>
              </div>


              <h3 className={classes.pageSubcategoriesTitle}>
                Job Card - {this.props.jobsData.viewJobDetails.jobCardNumber}
              </h3>


              <NavPills
                color="info"
                alignCenter
                tabs={[
                  {
                    tabButton: "Job Information",
                    tabIcon: Info,
                    tabContent: (
                      <Card>
                        <CardBody>
                          <Dialog
                            open={false}
                            // open={this.state.open}
                            onClose={() => { this.setState({ open: false }) }}
                            fullWidth
                          >
                            <DialogTitle>Assign New Contractor</DialogTitle>
                            <DialogContent>
                              <FormControl
                                fullWidth
                              >
                                <InputLabel
                                  htmlFor="simple-select"
                                >
                                  SELECT CONTRACTOR
                                  </InputLabel>
                                <Select
                                  classes={{
                                    select: classes.select
                                  }}
                                  onChange={this.handleSimple}
                                  inputProps={{
                                    name: "simpleSelect",
                                    id: "simple-select"
                                  }}
                                >
                                  <MenuItem
                                    disabled
                                  >
                                    Select Job Type
                                      </MenuItem>
                                  {
                                    ["tomatoes", "mangoes", "potatoes", "pineapples", "apples", "carrots", "cucumber"].map((contractor, index) => {
                                      return (<MenuItem
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected: classes.selectMenuItemSelected
                                        }}
                                        value={contractor}
                                      >
                                        {contractor}
                                      </MenuItem>)
                                    })
                                  }

                                </Select>
                              </FormControl>
                            </DialogContent>
                            <DialogActions>
                              <Button color="danger" variant="contained">Assign Contractor</Button>
                            </DialogActions>
                          </Dialog>

                          <Dialog
                            open={false}
                            // open={this.state.openInspectorDialog}
                            onClose={() => { this.setState({ openInspectorDialog: false }) }}
                            fullWidth
                          >
                            <DialogTitle>Assign New Inspector</DialogTitle>
                            <DialogContent>
                              <FormControl
                                fullWidth
                              >
                                <InputLabel
                                  htmlFor="simple-select"
                                >
                                  SELECT INSPECTOR
                                  </InputLabel>
                                <Select
                                  classes={{
                                    select: classes.select
                                  }}
                                  onChange={this.handleSimple}
                                  inputProps={{
                                    name: "simpleSelect",
                                    id: "simple-select"
                                  }}
                                >
                                  <MenuItem
                                    disabled
                                  >
                                    SELECT INSPECTOR
                                      </MenuItem>
                                  {
                                    ["tomatoes", "mangoes", "potatoes", "pineapples", "apples", "carrots", "cucumber"].map((contractor, index) => {
                                      return (<MenuItem
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected: classes.selectMenuItemSelected
                                        }}
                                        value={contractor}
                                      >
                                        {contractor}
                                      </MenuItem>)
                                    })
                                  }

                                </Select>
                              </FormControl>
                            </DialogContent>
                            <DialogActions>
                              <Button color="secondary" variant="contained">Assign Inspector</Button>
                            </DialogActions>
                          </Dialog>

                          <Dialog
                            open={false}
                            // open={this.state.openManagerDialog}
                            onClose={() => { this.setState({ openManagerDialog: false }) }}
                            fullWidth
                          >
                            <DialogTitle>Assign New Manager</DialogTitle>
                            <DialogContent>
                              <FormControl
                                fullWidth
                              >
                                <InputLabel
                                  htmlFor="simple-select"
                                >
                                  SELECT MANAGER
                                  </InputLabel>
                                <Select
                                  classes={{
                                    select: classes.select
                                  }}
                                  onChange={this.handleSimple}
                                  inputProps={{
                                    name: "simpleSelect",
                                    id: "simple-select"
                                  }}
                                >
                                  <MenuItem
                                    disabled
                                  >
                                    Select Job Type
                                      </MenuItem>
                                  {
                                    ["tomatoes", "mangoes", "potatoes", "pineapples", "apples", "carrots", "cucumber"].map((contractor, index) => {
                                      return (<MenuItem
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected: classes.selectMenuItemSelected
                                        }}
                                        value={contractor}
                                      >
                                        {contractor}
                                      </MenuItem>)
                                    })
                                  }

                                </Select>
                              </FormControl>
                            </DialogContent>
                            <DialogActions>
                              <Button color="secondary" variant="contained">Assign Mananger</Button>
                            </DialogActions>
                          </Dialog>
                          <form>

                            <GridContainer>
                              <br />
                              <br />
                              <GridContainer style={{ padding: "20px" }}>
                                <GridItem xs={12} sm={6} md={4}>
                                  <CustomInput

                                    labelText="Job Type"
                                    id="type"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      value: jobType,
                                      type: "text"
                                    }}
                                  />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                  <CustomInput
                                    labelText="Job Status "
                                    id="status"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      value: jobStatus,
                                      type: "text"
                                    }}
                                  />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                  <CustomInput
                                    labelText="Project Name "
                                    id="projectName"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      value: jobProjectName,
                                      type: "text"
                                    }}
                                  />
                                </GridItem>

                                <GridItem xs={12} sm={6} md={4}>
                                  <CustomInput
                                    labelText="Job Class"
                                    id="jobClass"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      type: "text",
                                      value: jobClass,
                                    }}
                                  />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                  <CustomInput
                                    labelText="Region"
                                    id="region"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      type: "text",
                                      value: region,
                                    }}
                                  />
                                </GridItem>
                                <GridItem xs={12} sm={6} md={4}>
                                  <CustomInput
                                    labelText="Municipality Reference Number"
                                    id="municipalityRefNumber"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      type: "text",
                                      value: municipalityRefNumber,
                                    }}
                                  />
                                </GridItem>

                                <GridItem xs={12} sm={6} md={4}>
                                  <CustomInput
                                    labelText="Contractor"
                                    id="contractor"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      type: 'text',
                                      value: jobContractor,
                                      endAdornment: (
                                        <InputAdornment
                                          position="end"
                                          className={classes.inputAdornment}
                                        >
                                          < MoreVertIcon style={{ margin: '0px', padding: "0px", color: "red" }} onClick={() => { this.setState({ open: true }) }} />

                                        </InputAdornment>
                                      )

                                    }}
                                  />
                                </GridItem>

                                <GridItem xs={12} sm={6} md={4}>
                                  <CustomInput
                                    labelText="Inspector"
                                    id="inspector"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      type: 'text',
                                      value: jobInspector,
                                      endAdornment: (
                                        <InputAdornment
                                          position="end"
                                          className={classes.inputAdornment}
                                        >
                                          < MoreVertIcon style={{ margin: '0px', padding: "0px", color: "red" }} onClick={() => { this.setState({ openInspectorDialog: true }) }} />

                                        </InputAdornment>
                                      )

                                    }}
                                  />
                                </GridItem>

                                <GridItem xs={12} sm={6} md={4}>
                                  <CustomInput
                                    labelText="Auditor"
                                    id="auditor"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      type: 'text',
                                      value: jobAuditor,
                                      endAdornment: (
                                        <InputAdornment
                                          position="end"
                                          className={classes.inputAdornment}
                                        >
                                          < MoreVertIcon style={{ margin: '0px', padding: "0px", color: "red" }} onClick={() => { this.setState({ open: true }) }} />

                                        </InputAdornment>
                                      )

                                    }}
                                  />
                                </GridItem>


                                <GridItem xs={12} sm={6} md={4}>
                                  <CustomInput
                                    labelText="Manager"
                                    id="manager"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      type: 'text',
                                      value: jobManager,
                                      endAdornment: (
                                        <InputAdornment
                                          position="end"
                                          className={classes.inputAdornment}
                                        >
                                          < MoreVertIcon style={{ margin: '0px', padding: "0px", color: "red" }} onClick={() => { this.setState({ openManagerDialog: true }) }} />

                                        </InputAdornment>
                                      )

                                    }}
                                  />
                                </GridItem>

                                <GridItem xs={12} sm={4} md={4}>
                                  <br />
                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={jobPriority}
                                        value={jobPriority}
                                      />
                                    }
                                    classes={{
                                      label: classes.label
                                    }}
                                    label="Priority"
                                  />
                                </GridItem>
                                <GridItem xs={12} sm={12} md={12}>
                                  <CustomInput
                                    labelText="Old Meter Number"
                                    id="oldMeterNumber"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      type: "text",
                                      value: oldMeterNumber,
                                    }}
                                    multiline
                                    rowsMax="4"
                                  />
                                </GridItem>

                                <GridItem xs={12} sm={12} md={12}>
                                  <CustomInput
                                    labelText="Job instructions"
                                    id="registerconfirmpassword"
                                    formControlProps={{
                                      fullWidth: true
                                    }}
                                    inputProps={{
                                      type: "text",
                                      value: jobInstructions,
                                    }}
                                    multiline
                                    rowsMax="4"
                                  />
                                </GridItem>
                              </GridContainer>

                            </GridContainer>

                          </form>
                        </CardBody>
                      </Card>
                    )
                  },




















                  // stand information
                  {
                    tabButton: "Stand Information",
                    tabIcon: StandInfo,
                    tabContent: (
                      <Card>
                        <CardBody>
                          <form>
                            <GridContainer>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput

                                  labelText="Town  *"
                                  id="town"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: standInfo.town,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Stand No *"
                                  id="standNumber"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: standInfo.standNumber,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Subdivision *"
                                  id="subdivision"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: standInfo.subdivision,
                                    type: "text"
                                  }}
                                />
                              </GridItem>

                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText=" Address  *"
                                  id="physicalAddress"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: standInfo.physicalAddress,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Latitude *"
                                  id="latitude"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: standInfo.latitude,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Longitude *"
                                  id="longitude"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: standInfo.longitude,
                                    type: "text"
                                  }}
                                />
                              </GridItem>


                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Account No *"
                                  id="accountNumber"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: standInfo.accountNumber,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Venus No *"
                                  id="venusNumber"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: standInfo.venusNumber,
                                    type: "text"
                                  }}
                                />
                              </GridItem>

                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Portion  *"
                                  id="town"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: standInfo.portion,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Contact Person *"
                                  id="contactPerson"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: standInfo.contactPerson,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Contact No *"
                                  id="contactPhone"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: standInfo.contactPhone,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                            </GridContainer>
                          </form>
                        </CardBody>
                      </Card>
                    )
                  },















                  {
                    tabButton: "Meter Information",
                    tabIcon: Meter,
                    tabContent: (
                      <Card>

                        <CardBody>
                          <form>
                            <GridContainer>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput

                                  labelText="Meter Type"
                                  id="meterType"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.meterType,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Meter Payment Type"
                                  id="meterPaymentType"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.meterPaymentType,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Meter Condition"
                                  id="condition"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.condition,
                                    type: "text"
                                  }}
                                />
                              </GridItem>

                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText=" Meter Dial Type"
                                  id="meterDialType"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.meterDialType,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Brand"
                                  id="brand"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.brand,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Model"
                                  id="model"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.model,
                                    type: "text"
                                  }}
                                />
                              </GridItem>


                              <GridItem xs={12} sm={4} md={4}>
                                <CustomInput
                                  labelText="Tag"
                                  id="tag"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.tag,
                                    type: "text"
                                  }}
                                />
                              </GridItem>

                            </GridContainer>

                            <GridContainer>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Meter Number"
                                  id="meterNumber"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.meterNumber,
                                    type: "text"
                                  }}
                                />
                              </GridItem>

                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Meter Serial Number"
                                  id="meterSerialNumber"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.meterSerialNumber,
                                    type: "text"
                                  }}
                                />
                              </GridItem>

                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Meter Reading"
                                  id="meterReading"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.meterReading,
                                    type: "text"
                                  }}
                                />
                              </GridItem>



                            </GridContainer>
                            <GridContainer>
                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Key Change 1"
                                  id="keyChange1"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.keyChange1,
                                    type: "text"
                                  }}
                                />
                              </GridItem>

                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Key Change 2"
                                  id="keyChange2"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.keyChange2,
                                    type: "text"
                                  }}
                                />
                              </GridItem>




                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Temper Reset"
                                  id="temperReset"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.temperReset,
                                    type: "text"
                                  }}
                                />
                              </GridItem>

                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Power Limit"
                                  id="powerLimit"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.powerLimit,
                                    type: "text"
                                  }}
                                />
                              </GridItem>

                              <GridItem xs={12} sm={6} md={4}>
                                <CustomInput
                                  labelText="Preloaded Meter Units Token"
                                  id="preloadedMeterUnitsToken"
                                  formControlProps={{
                                    fullWidth: true
                                  }}
                                  inputProps={{
                                    value: meterInfo.preloadedMeterUnitsToken,
                                    type: "text"
                                  }}
                                />
                              </GridItem>
                            </GridContainer>
                          </form>
                        </CardBody>
                      </Card>
                    )
                  },
                  {
                    tabButton: "Work Execution",
                    tabIcon: Work,
                    tabContent: (
                      <Card>
                        <CardBody>

                          <WorkDone job={job} />


                        </CardBody>
                      </Card>
                    )
                  },

                  {
                    tabButton: "Location Information",
                    tabIcon: LocationOn,
                    tabContent: (
                      <Card>
                        <CardBody>
                          <Card>
                            <CardHeader color="rose" icon>
                              <CardIcon color="rose">
                                <Place />
                              </CardIcon>
                              <h4 className={classes.cardIconTitle}>
                                {standInfo.physicalAddress + '   ' + ' (' + standInfo.latitude + ', ' + standInfo.longitude + ')'}
                              </h4>
                            </CardHeader>
                            <CardBody>
                              <CustomSkinMap
                                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}`}
                                loadingElement={<div style={{ height: `100%` }} />}
                                containerElement={
                                  <div
                                    style={{
                                      height: `580px`,
                                      borderRadius: "6px",
                                      overflow: "hidden"
                                    }}
                                  />
                                }
                                mapElement={<div style={{ height: `100%` }} />}
                                latitude={standInfo.latitude}
                                longitude={standInfo.longitude}
                                jobCardNumber={jobCardNumber}
                              />
                            </CardBody>
                          </Card>





                        </CardBody>
                      </Card>
                    )
                  },
                  {
                    tabButton: "Job Audit Trail",
                    tabIcon: Audit,
                    tabContent: (
                      <Card style={{ backgroundColor: "#999" }}>
                        <CardBody>
                          <GridContainer style={{ textAlign: "center" }}>
                            <GridItem xs={12} sm={8} md={8} style={{ margin: "auto" }} >
                              <Timeline stories={jobTrail} />

                            </GridItem>
                          </GridContainer>
                        </CardBody>
                      </Card>
                    )
                  },
                ]}
              />
            </GridItem>
          </GridContainer>
        </div>
      );
    }
    else if (this.props.jobsData.viewJobErrors) {
      return (
        <div style={{ textAlign: "center" }}>
          <h1>We could not find Job Number: {this.props.jobNumber}</h1>
          <Grid item xs={12}>
            <Button color="secondary" variant="contained" style={{ margin: "13px", backgroundColor: "#26c6da", color: 'white' }} onClick={() => this.props.goToPage('/admin/create/jobcard')}>Create a new Job</Button>
            <Button color="secondary" variant="contained" style={{ margin: "13px", backgroundColor: "#26c6da", color: 'white' }} onClick={() => this.props.goToPage('/admin/jobcards')}> View All Jobs</Button>
            <Button color="secondary" variant="contained" style={{ margin: "13px", backgroundColor: "#26c6da", color: 'white' }} onClick={() => this.props.goToPage('/admin/workspace')}>View My Workspace Jobs</Button>
          </Grid>

        </div>
      )
    }
    else return (
      <div style={{ textAlign: "center" }}>
        <CircularProgress color="secondary" />
        <h1>Loading Details Job Number:{this.propsjobNumber}</h1>
      </div>)
  }
}

export default withStyles(styles)(
  connect(state => ({
    jobsData: state.jobCardState,
    audits: state.jobAuditState,
  }))(JobCardViewComponent)
);